<div class="modal-body">
    <div class="row">
      <div class="col-md-12">
        <div *ngIf="canUploadFileCount > uploadedFiles.length" class="form-group row">
          <label class="col-md-3 col-form-label">Select Files</label>
          <div class="col-md-9">
            <label for="file-input" class="upload-lnk">Click here to Choose
              File</label>
            &nbsp;&nbsp;
            <div class="text-danger">
              Maximum {{canUploadFileCount}} files can be uploaded (each file size upto 50 MB)
            </div>
            <!-- <input id="file-input" #doc type="file" multiple (change)="handleFileInput($event.target.files)" /> -->
            <input id="file-input" #fileInput type="file" multiple (click)="fileInput.value = ''" value="" (change)="handleFileInput($event)" >
          </div>
        </div>
        <div class="row" *ngIf="uploadedFiles.length > 0">
          <div class="col-md-12">
            <table nz-table class="table table-bordered table-striped table-textCenter" aria-describedby="row">
              <thead>
                <tr>
                  <th class="thead text-center">File Name</th>
                  <th class="thead text-center">Remove</th>
                </tr>
              </thead>
              <tbody *ngIf="uploadedFiles.length > 0">
                <tr *ngFor="let file of uploadedFiles;let i=index">
                  <td class="text-center"><strong>{{file.name}}</strong></td>
                  <td class="text-center">
                    <a (click)="removeFile(i)" style="cursor: pointer;">X
                      <span title="remove file" class="glyphicon glyphicon-remove"></span></a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
